var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{class:{
    disabledArrow: _vm.disableButtons || _vm.preventArrow,
    hide: _vm.hideButton,
  },attrs:{"color":"#ead148","text":"","id":"riddleAnswerBtn"}},[_c('v-icon',{staticClass:"pa-3",attrs:{"id":"arrow","x-large":""}},[_vm._v("mdi-arrow-right-thick")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }